import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class ShiftService {
  private socket?: SocketService;

  constructor(private httpClient: HttpClient, private apiService: ApiService) { }

  public initSocket() {
    this.socket = new SocketService(this.apiService)
  }

  public listen(): Observable<any> {
    if (!this.socket) {
      console.warn('Socket accessed before initialization in ShiftService.initSocket()');
      return new Observable();
    }

    return this.socket?.fromEvent('update')
  }

  public addFile(shiftId: number, picture: any): Observable<any> {

    const formData = new FormData()
    formData.set('show_to_employee', 'true')
    formData.set('file', picture.file)

    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}/files`, formData);
  }

  public cancel(shiftId: number, reson: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}/cancel`, { cancel_reason: reson });
  }

  public employees(data: {}): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/employees`, data);
  }

  public checkout(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/shifts/checkout`, data);
  }

  public order(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/shifts/order`, data);
  }

  public product(shiftId: number, productId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}/products/${productId}`);
  }

  public productAdd(shiftId: number, data: any, save?: boolean): Observable<any> {
    data.save = !!save

    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}/products`, data);
  }

  public save(shiftId: number | null, data: {}): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId ? shiftId : ''}`, data);
  }

  public shift(shiftId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}`);
  }

  public recent(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/shifts/recent`);
  }

  public next(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/shifts/next`);
  }

  public shifts(params: {}): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/shifts`, { params: new HttpParams({ fromObject: params }) });
  }

  public upcomingRelated(shiftId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}/related/upcoming`);
  }

  public verify(shiftId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/shifts/${shiftId}/verify`);
  }
}
